/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeartRateMonitor = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M2 2h20v20H2zm2 2v6.778h2.341l2.257-2.91 3.422 4.911 3.953-5.407 2.817 3.406H20V4zm16 8.778h-2.151l-1.778-2.15-4.09 5.593-3.47-4.978-1.19 1.535H4V20h16z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgHeartRateMonitor as HeartRateMonitor };
